import styled from 'styled-components';
import { toRem, baseVariables } from '../../styles';

export const StyledError = styled.div`
  background-color: ${baseVariables.color['neutral20']};
  margin: ${toRem(32)} 0px;
  border-radius: ${toRem(14)};
  padding: ${toRem(80)} 0;

  display: flex;
  align-items: center;
  justify-content: center;

  color: ${baseVariables.color['neutral40']};
  font-size: ${toRem(14)};
  line-height: ${toRem(21)};
  font-weight: ${baseVariables.font['fontWeightRegular']};
  width: 100%;
`;

export const StyledPreferredCardCheckbox = styled.div`
  .checkbox {
    padding: ${toRem(8)} 0;
  }
  .checkbox input[type='checkbox'] {
    position: absolute;
    opacity: 0;
    width: ${toRem(1)};
    height: ${toRem(1)};
  }

  .checkbox label {
    position: relative;
    margin: 0;
    padding-left: ${toRem(34)};
    font-size: ${toRem(16)};
    font-weight: ${baseVariables.font['fontWeightRegular']};
    line-height: ${toRem(24)};
    color: ${baseVariables.color['neutral100']};
    cursor: pointer;
  }

  .checkbox label:before {
    top: 2px;
  }

  .checkbox label::before {
    content: '';
    position: absolute;
    left: 0;
    width: ${toRem(18)};
    height: ${toRem(18)};
    border: ${toRem(1)} solid ${baseVariables.color['neutral100']};
    border-radius: ${toRem(2)};
    background: ${baseVariables.color['white']};
    text-align: center;
  }

  .checkbox label:after {
    top: 4px;
  }

  .checkbox input[type='checkbox']:checked + label:after {
    opacity: 1;
    border-bottom: 2px solid ${baseVariables.color['white']};
    border-right: 2px solid ${baseVariables.color['white']};
  }

  .checkbox input[type='checkbox']:checked + label::after {
    background-color: transparent;
    content: '';
    display: block;
    position: absolute;
    left: ${toRem(6)};
    width: ${toRem(6)};
    height: ${toRem(12)};
    opacity: 0.2;
    border-bottom: ${toRem(2)} solid ${baseVariables.color['base-20']};
    border-right: ${toRem(2)} solid ${baseVariables.color['base-20']};
    transform: rotate(45deg);
  }

  .checkbox input[type='checkbox']:focus-visible + label {
    outline: ${toRem(2)} solid ${baseVariables.color['neutral100']};
    outline-offset: ${toRem(2)};
  }
`;
